// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3300":"e2ff9ce5","6362":"b77321f4","6704":"4a0290d7","8580":"b77321f4"}[chunkId] + ".chunk.css";
};